export const EMPTY_SUPPORTING_DOCUMENTS = [];

export const EMPTY_DOCUMENT_TYPES_OPTIONS = [];
